module.exports = __webpack_public_path__ + "gr.svg?1eee8319085a21e25a3a8a0f82b087cc";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gr.svg
// module id = 1015
// module chunks = 27